import React from "react";
import "./BulkActionsBar.scss";

export interface BulkAction {
  id: string;
  label: string;
  onClick: () => void;
  variant?: "success" | "warning" | "danger" | "default";
  disabled?: boolean;
}

export interface BulkActionsBarProps {
  selectedCount: number;
  actions: BulkAction[];
  onClear?: () => void;
  isLoading?: boolean;
  itemLabel?: string;
}

const BulkActionsBar: React.FC<BulkActionsBarProps> = ({
  selectedCount,
  actions,
  onClear,
  isLoading = false,
  itemLabel = "მონიშნული",
}) => {
  if (selectedCount === 0) return null;

  return (
    <div className="bulk-bar">
      <span className="bulk-bar__count">{selectedCount}</span>
      <span className="bulk-bar__label">{itemLabel} მონიშნულია</span>
      <div className="bulk-bar__actions">
        {actions.map((action) => (
          <button
            key={action.id}
            className={`bulk-bar__btn bulk-bar__btn--${action.variant ?? "default"}`}
            disabled={isLoading || action.disabled}
            onClick={action.onClick}
          >
            {action.label}
          </button>
        ))}
      </div>
      {onClear && (
        <button className="bulk-bar__clear" onClick={onClear} disabled={isLoading}>
          ✕
        </button>
      )}
    </div>
  );
};

export default BulkActionsBar;
